import React, { useEffect, useState } from 'react'
import Modal from '../../components/common/modal/Modal'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { BsDatabaseFillX } from 'react-icons/bs'
import { accountingAxios } from '../../config/axios'
import toast from 'react-hot-toast'
import TableFilter from '../../components/common/table-filter/TableFilter'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { enteredToTally } from '../../redux/features/serviceSlice'
import FilterBill from '../../components/user/finance/FilterBill'


const Bills = () => {
    const [modal, setModal] = useState({ status: false })
    const [data, setData] = useState([])
    const [loading, setLoading] = useState('fetch')
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams()
    const { markService } = useSelector((state) => state.service)

    const handleEnteredToTally = (id) => {
        dispatch(enteredToTally(id))
    }


    useEffect(() => {
        accountingAxios.get('/v2/bills', {
            params: {
                status: searchParams.get('status'),
                bill_type: searchParams.get('bill_type'),
                bill_no: searchParams.get('bill_no'),
                from_date: searchParams.get('from_date'),
                end_date: searchParams.get('end_date'),
                taxable: searchParams.get('taxable'),
                source: searchParams.get('source'),
                party_id: searchParams.get('party_id'),
                party_type: searchParams.get('party_type'),
                ref_id: searchParams.get('ref_id'),
                ref_type: searchParams.get('ref_type'),
                price_start: searchParams.get('price_start'),
                price_end: searchParams.get('price_end')
            }
        }).then((response) => {
            setData(response.data)
            setLoading('')
        }).catch((error) => {
            toast.error(error.message)
            setLoading('')
        })
        // eslint-disable-next-line
    }, [searchParams.get('from_date'), searchParams.get('end_date'), searchParams.get('bill_no'), searchParams.get('receipt_no'),
    // eslint-disable-next-line
    searchParams.get('status'), searchParams.get('bill_type'), searchParams.get('taxable'), searchParams.get('source'),
    // eslint-disable-next-line
    searchParams.get('party_id'), searchParams.get('party_type'), searchParams.get('ref_id'), searchParams.get('ref_type'),
    // eslint-disable-next-line
    searchParams.get('price_start'), searchParams.get('price_end')
    ])

    const filterModal = () => {
        setModal({
            status: true,
            title: "Filter",
            content: <FilterBill setModal={setModal} />
        })
    }

    return (
        <div className="bills-list">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Bills']}>
                {data[0] ? <TableFilter
                    topRight={<button onClick={filterModal}>Filter</button>}
                >
                    <table>
                        <thead>
                            <tr>
                                <th>Bill No</th>
                                <th>Type & Tax</th>
                                <th>Issue Date</th>
                                <th>Status</th>
                                <th>Source</th>
                                <th>Party</th>
                                <th>Ref.</th>
                                <th>Version</th>
                                <th>Total Amount</th>
                                <th>Payment</th>
                                <th>Mark</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) => (
                                <tr key={index} >
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.bill_no}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.bill_type} {item?.tax_applicable ? '(Tax)' : ""}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.bill_date ? new Date(item?.bill_date).toDateString() : ''}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.status}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.source}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.party?.type} / {item?.party?.id}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.reference_type}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.version}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        ₹ {item?.total_amount}
                                    </td>
                                    <td style={{ cursor: 'pointer' }} onClick={() => navigate(`/bill/${item?.uuid}?view_type=Group base`)}  >
                                        {item?.payment_status}
                                    </td>
                                    <td style={{ cursor: 'pointer' }}> {item?.status === 'ISSUED'
                                        && <input type='checkbox' checked={markService?.includes(item.uuid)} onClick={() => handleEnteredToTally(item.uuid)} />} </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </TableFilter>
                    : <SpinWithMessage icon={!loading && <BsDatabaseFillX />} message={loading ? 'Fetch data...' : 'No data'} spin={loading}
                        bottomContent={<>
                            <button onClick={filterModal}>Filter</button>
                        </>} />
                }
            </SinglePage>
        </div >
    )
}

export default Bills